import useFormatDate from 'src/app/hooks/current-locale/use-format-date'
import { faMoon, faPlaneArrival, faPlaneDeparture } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { HicChip } from '../hic-chip/hic-chip'
import { differenceInDays } from 'date-fns'
import { Box, Stack } from '@vapor/material'

export default function RangeDateCell({ start, end }: { start: Date; end: Date }) {
  const formatDate = useFormatDate()
  return (
    <Stack spacing={0.5} alignItems={'start'} marginY={0.5}>
      <Box>
        <FontAwesomeIcon icon={faPlaneArrival} /> {formatDate(start)}
      </Box>
      <Box>
        <FontAwesomeIcon icon={faPlaneDeparture} /> {formatDate(end)}
      </Box>
      <HicChip text={differenceInDays(end, start).toString()} icon={faMoon} textStyle="normal" color="white" borderColor="var(--QuickSilver)" borderStyle="solid" />
    </Stack>
  )
}
